module.exports = __webpack_public_path__ + "img/ES_AR_noveltyBadge.a90f738c.svg";